import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { apiService } from '../../../services/apiService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faEnvelope, faMagnifyingGlass, faPhone } from '@fortawesome/free-solid-svg-icons';
import { Link, useParams } from 'react-router-dom';
function RecentApplyJobsSeeker() {
    // const UserId = localStorage.getItem('userid');

    // Recent jobs
    const { id } = useParams();
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const [jobslist, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);

    const fetchJobs = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const response = await apiService.postRequest(`/admin/jobseeker-applied-job-posts/${id}`, params);

            if (response && response.success === true) {
                setJobs(response.data || []);
                setPaginateData(response.meta);
            } else {
                if (response.authenticate === false) {
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [id]);

    // Handle page change
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchJobs({ page: newPage });
    };

    // Handle search query change
    const handleSearch = () => {
        setCurrentPage(1);
        fetchJobs({ search: searchQuery });
    };

    useEffect(() => {
        fetchJobs();
    }, [fetchJobs]);
  return (  
    <Grid size={{xs:12}} container className="border_recentdashboard" alignContent="flex-start">
        <Grid size={{xs:12}} container justifyContent="flex-end">
            <Grid size={{ sm:5 ,xs: 12 }} container flexDirection="column">
                <div className='d-flex jobseekersearch my-3'>
                    <div className='col-md-9 input_jobssearch'>
                        <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                        <input type='text' placeholder='search'
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleSearch(); // Trigger search on Enter key press
                            }
                        }}/>
                    </div>
                    <div className='col-md-3 col-4'>
                        <button onClick={handleSearch}>Search</button>
                    </div>
                </div>
            </Grid>
        </Grid>
        {loading ? 
            <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
            </div> :<>
            {jobslist && jobslist.length > 0 ? (<>
                {jobslist && jobslist.map((jobslist,index) => (
                <Grid size={{xs:12}} container key={index} justifyContent="space-between" className="pt-3 last_borderdash">
                    <Grid container className="titleadmin_joblist mb-0">
                        {jobslist && jobslist.source === "LinkedIn" ? 
                            <img src={require("../../../assets/sample/linkedin.svg").default} alt='Job Icon'/>:
                            jobslist.source === "Monster" ?
                            <img src={require("../../../assets/sample/monster.svg").default} alt='Job Icon'/>:
                            jobslist.source === "Indeed" ?
                            <img src={require("../../../assets/sample/indeed.svg").default} alt='Job Icon'/>:
                            jobslist.source === "Glassdoor" ?
                            <img src={require("../../../assets/sample/glassdoor.svg").default} alt='Job Icon'/>:
                            jobslist.source === "Dice" ?
                            <img src={require("../../../assets/sample/dice.svg").default} alt='Job Icon'/>:
                            jobslist.source === "Techfetch" ?
                            <img src={require("../../../assets/sample/techfetch.svg").default} alt='Job Icon'/>:
                            jobslist.source === "TekP Intelligence" ?
                            <img src={require("../../../assets/sample/tekp.svg").default} alt='Job Icon'/>:
                            <img src={require("../../../assets/sample/others.svg").default} alt='Job Icon'/>}
                        
                        <div className='jobboard_listtitle'>
                            {permissionstest && permissionstest.manage_job_posts === true && permissionstest.manage_job_post_viewer === true ?
                                <Link className='link_joblist' target='_blank' to={`/job-board/view-job/${jobslist.job_id}`}><h5 className='tittle_jobswrap'>{jobslist.title}</h5></Link>:
                                <h6 className='tittle_jobswrap' style={{color:"unset"}}>{jobslist.title}</h6>
                            }
                            <small className='mb-0'>{jobslist && jobslist.location && jobslist.location !== "" && jobslist.location !== "unknown" && jobslist.location}{jobslist && jobslist.location && jobslist.location !== "" && jobslist.location !== "unknown" && jobslist.recruiter_company && jobslist.recruiter_company !== "" && jobslist.recruiter_company !== "unknown" && ' -'} {jobslist && jobslist.recruiter_company && jobslist.recruiter_company !== "" && jobslist.recruiter_company !== "unknown" && jobslist.recruiter_company }</small>
                        </div>
                    </Grid>
                    <Grid container alignItems="center" justifyContent="flex-end" className="endcardjobboard">
                        {/* <span className='total_jobs'>Job Id : <span>{jobslist.job_id}</span></span> */}
                        {jobslist && jobslist.recruiter_email && jobslist.recruiter_email[0] !== "" && jobslist.recruiter_email[0] !== "unknown" &&
                            <span className="hover_showes">
                                <FontAwesomeIcon icon={faEnvelope} />
                                <span>
                                {jobslist.recruiter_email[0]}
                                {jobslist.recruiter_email.length > 1 && " ..."}
                                </span>
                            </span>
                        }
                        {jobslist && jobslist.recruiter_phone && jobslist.recruiter_phone !== "" && jobslist.recruiter_phone !== "unknown" &&
                            <span className='hover_showes'><FontAwesomeIcon icon={faPhone} />
                                <span>{jobslist.recruiter_phone}</span>
                            </span>
                        }
                    </Grid>
                    <span className="w-100 text-end">{jobslist.applied_at || jobslist.created_at}</span>
                </Grid>
            ))}
            <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                <button className='arrowpaginate'
                    onClick={() => handlePageChange(currentPage - 1)} 
                    disabled={currentPage === 1}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                {paginatedata && paginatedata.last_page > 0 && (
                    <div className="pagination">
                        {(() => {
                        const totalPages = Math.max(1, paginatedata.last_page);
                        const pages = [];

                        const start = Math.max(2, currentPage - 2);
                        const end = Math.min(totalPages - 1, currentPage + 2);

                        // Always show page 1
                        pages.push(
                            <button
                            key={1}
                            onClick={() => handlePageChange(1)}
                            className={currentPage === 1 ? 'active' : ''}
                            >
                            1
                            </button>
                        );

                        // Ellipsis after page 1 if needed
                        if (start > 2) {
                            pages.push(<span key="start-ellipsis">...</span>);
                        }

                        // Middle pages
                        for (let i = start; i <= end; i++) {
                            pages.push(
                            <button
                                key={i}
                                onClick={() => handlePageChange(i)}
                                className={currentPage === i ? 'active' : ''}
                            >
                                {i}
                            </button>
                            );
                        }

                        // Ellipsis before last page if needed
                        if (end < totalPages - 1) {
                            pages.push(<span key="end-ellipsis">...</span>);
                        }

                        // Always show last page (if more than 1)
                        if (totalPages > 1) {
                            pages.push(
                            <button
                                key={totalPages}
                                onClick={() => handlePageChange(totalPages)}
                                className={currentPage === totalPages ? 'active' : ''}
                            >
                                {totalPages}
                            </button>
                            );
                        }

                        return pages;
                        })()}
                    </div>
                )}
                <button className='arrowpaginate'
                    onClick={() => handlePageChange(currentPage + 1)} 
                    disabled={currentPage === paginatedata.last_page}>
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </Grid>
            </>) : (
                <div className="w-100 d-flex justify-content-center mt-4">
                    <p>No data to display</p>
                </div>
            )}
        </>}
    </Grid>
  )
}

export default RecentApplyJobsSeeker
